// import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
// import { ProductDetailsDescriptionService } from '../_services/product-details-description.service';
// import { ActivatedRoute } from '../../../node_modules/@angular/router';
// import { ProductDetailsDescription } from '../_models/ProductDetailsDescription';
// import { CookieService } from '../../../node_modules/ngx-cookie-service';



// @Component({
//     selector: 'app-home',
//     templateUrl: './home.component.html',
//     styleUrls: ['./home.component.css']
// })
// export class HomeComponent implements OnInit{
   
//     id:any;
//     productImageUrl: String;
//     productDetailsDescription: ProductDetailsDescription
//     productId: string=null;
//     clientId: string;
//     userId: number;
//     loading : boolean = false;
//     data:any =[];
//     content: any;
//      imagesUrl: string[];
   
    
    
//     constructor(
//         private featuredProductService:ProductDetailsDescriptionService,
//         private cookieService: CookieService,
//     ) { 
       
//         }
//         // transform(imageUrl:string):SafeHtml {
//         //     return this.sanitizer.bypassSecurityTrustHtml(imageUrl);
//         //     console.log("sbhjh", this.imageUrl)
//         //   }
       

//     ngOnInit() {
//         // this.getAllProducts(event)
//         this.cookieService.set('clientId','1');
//         this.cookieService.set('categoryId','');
//         console.log(event)

//         this.imagesUrl = ['../../assets/img/home18.jpg', '../../assets/img/drapery10.png', '../../assets/img/drapery11.png','../../assets/img/drapery12.png','../../assets/img/drapery13.png','../../assets/img/drapery16.png'];
      
        
//     }

   

//     // getAllProducts(event) {
//     //     try {
//     //       this.productId = null;
//     //       this.clientId = this.cookieService.get('clientId');
//     //       this.userId= 1;
//     //       this.loading = true;
//     //     //   this.featuredProductService.getAllProducts(this.productId,this.clientId,this.userId)
//     //       .subscribe(
//     //         resp => {
//     //         this.loading = false;  
//     //         this.data = resp ;
//     //         console.log(this.data)
//     //         this.data.filter(respNew=>{
//     //             if(respNew.isFeaturedProduct===true){
//     //             respNew.images.filter(imageResp=>{
//     //                 console.log(imageResp.path)
//     //                 this.imagesUrl=imageResp.path;

//     //             })
//     //         }
//     //         })
            
//     //        return this.data;
//     //       },(error: any) => {
//     //           this.loading = false;
//     //           console.error('getCategories Request Throw Error', error);
//     //       });
//     //     } 
//     //     catch (error) {
//     //       this.loading = false;
//     //       console.error(' Error in getCategories Request', error);
//     //     }
//     //   }

//     // public config: SwiperConfigInterface = {
//     //     a11y: true,
//     //     direction: 'horizontal',
//     //     slidesPerView: 'auto',
//     //     speed: 500,
//     //     keyboard: false,
//     //     mousewheel: false,
//     //     scrollbar: false,
//     //     navigation: false,
//     //     pagination: true,
//     //     autoplay: {
//     //         delay: 2500,
//     //     }
//     // };

   

// }



import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { HomeProductService } from '../_services/home-product.service';
import { Banner } from '../_models/banner';
import { faLongArrowAltLeft, faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    // Page metadata
    page_type: string = 'home';
    title: string = "Home Fabrics - Home";

    // Data properties
    result: any[] = [];      // bannerGet
    products: any[] = [];    // master product list
    newArrival: any[] = [];
    nowTrending: any[] = [];
    bestSelling: any[] = [];
    ifr: any[] = [];
    currentIndex: number = 0;
    slideInterval: any;

    loading: boolean = false;
    private bannersLoaded: boolean = false;
    private productsLoaded: boolean = false;
    imgBaseUrl: string = environment.stockURL;
    detailLinkBase: string = environment.stockURL + 'home-fabrics-ui/#/product/';
    category_type: string = 'new-arrivals';
    faArrowRight = faLongArrowAltRight;
    faArrowLeft = faLongArrowAltLeft;

    constructor(
        private titleService: Title,
        private cookieService: CookieService,
        private homeProductService: HomeProductService
    ) { }

    ngOnInit() {
        // Preserving existing cookie initialization
        this.cookieService.set('clientId', '1');
        this.cookieService.set('categoryId', '');
        // Load Home Page Data
        this.index();
        this.startAutoSlide();
    }

    ngOnDestroy() {
        if (this.slideInterval) {
            clearInterval(this.slideInterval);
        }
    }

    startAutoSlide() {
        if (this.slideInterval) clearInterval(this.slideInterval);
        this.slideInterval = setInterval(() => {
            this.nextSlide();
        }, 6000); // Change slide every 6 seconds
    }

    nextSlide() {
        if (this.result.length > 0) {
            this.currentIndex = (this.currentIndex + 1) % this.result.length;
        }
    }

    prevSlide() {
        if (this.result.length > 0) {
            this.currentIndex = (this.currentIndex - 1 + this.result.length) % this.result.length;
        }
    }

    goToSlide(index: number) {
        this.currentIndex = index;
        this.startAutoSlide(); // Reset timer when user manually interacts
    }

    /**
     * Home Page Entry Point
     * Mimics PHP index() method
     */
    index() {
        this.page_type = 'home';
        this.title = "Home Fabrics - Home";
        this.titleService.setTitle(this.title);

        // Data retrieval calls
        this.bannerGet();
        this.productGet();

        // Scroll to top
        window.scrollTo(0, 0);
    }

    /**
     * Category Page Entry Point
     * Mimics PHP productCategory() method
     */
    productCategory(type: string = 'new-arrivals') {
        this.page_type = 'category';
        this.category_type = type;
        this.title = "Home Fabrics - " + this.getCategoryTitle(type);
        this.titleService.setTitle(this.title);

        // Scroll to top when moving to category view
        window.scrollTo(0, 0);
    }

    getCategoryTitle(type: string): string {
        switch (type) {
            case 'now-trending': return "Now Trending";
            case 'best-selling': return "All Time Best Selling";
            case 'sales-clearance': return "Inherent Flame Retardant (IFR) Fabric";
            default: return "New Arrivals";
        }
    }

    /* --- DATA RETRIEVAL METHODS (Converted from PHP Controller/Model logic) --- */

    bannerGet() {
        this.homeProductService.getBannerProduct().subscribe(
            (res: Banner[]) => {
                // Map to local assets path
                // this.result = res.map(item => 'assets/' + item.image);
                console.log("API BANNER RESPONSE:", res);
                // this.result = res.map(item => '/' + item.image);

                this.result = res
                .filter(item => item.status === true)   // ✅ only active banners
                .map(item => '/' + item.image);         // ✅ then map path
                
                console.log('Banners fetched:', this.result);
                this.loading = true;
            },
            err => console.error('Error fetching banners:', err)
        );
    }

    productGet() {
        this.homeProductService.getProducts().subscribe(
            res => {

                console.log("FULL API RESPONSE:", res);

                this.products = res;

                // Helper to map product into simplified structure with full image URL
                const mapProduct = (p: any) => ({
                    productId: p.productId,
                    productName: p.productName,
                    image: this.imgBaseUrl + (p.images && p.images.length > 0 ? p.images[0].url : '')
                });

                // Filtering and mapping based on API response flags
                this.newArrival = res.filter((p: any) =>  p.newArrivals === true).map(mapProduct);

                this.nowTrending = res.filter((p: any) => p.nowTrending === true).map(mapProduct);
                this.bestSelling = res.filter((p: any) => p.allTimeBestSelling === true).map(mapProduct);
                this.ifr = res.filter((p: any) => p.salesAndClearance === true).map(mapProduct);
            },
            err => console.error('Error fetching products:', err)
        );
    }

    private checkLoadingStatus() {
        if (this.bannersLoaded && this.productsLoaded) {
            // Add a small delay for smoother transition
            setTimeout(() => {
                this.loading = true;
            }, 500);
        }
    }


}
